/** Children one under another with a gap from the space scale. The default layout of a page and a card. */
import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './Layout.module.css'

export type Gap = 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export function Stack({ gap = 'md', children, as: As = 'div', label }: { gap?: Gap; children: ReactNode; as?: 'div' | 'section' | 'ul' | 'ol'; label?: string }) {
  return (
    <As className={cx(s.stack, s[`gap-${gap}`])} aria-label={label}>
      {children}
    </As>
  )
}
